/**
 * @generated SignedSource<<110fc61463ec9dc9dc540f2fd863aec0>>
 * @relayHash 5c9cf02614830a7e386c9b23c475de1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 20c390566178c3ea43db41cfc15658fc912f9ab857f8252b9bfa2284af77da35

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type preloadLivePageDataQuery$variables = {
  contentId: string;
  includeContentState?: boolean | null;
  includeCustomHeaderAndFooter: boolean;
  isUsdSsr: boolean;
  spaceKey: string;
  status?: ReadonlyArray<string | null> | null;
  userId?: string | null;
};
export type preloadLivePageDataQuery$data = {
  readonly availableContentStates?: {
    readonly customContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
    } | null> | null;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null> | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentProperties: {
        readonly latest: {
          readonly defaultTitleEmoji: string | null;
        } | null;
      } | null;
      readonly contentState?: {
        readonly color: string;
        readonly id: string | null;
        readonly isCallerPermitted: boolean | null;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null;
      readonly contentStateLastUpdated?: {
        readonly value: string;
      } | null;
      readonly emojiTitleDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly emojiTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
      readonly labels: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly name: string | null;
        } | null> | null;
      } | null;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly isFavourite: boolean | null;
          } | null;
        } | null;
        readonly frontend: {
          readonly coverPictureWidth: string | null;
        } | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly accountId?: string | null;
          readonly type: string | null;
        } | null;
        readonly ncsStepVersion: string | null;
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly publicLinkPage?: {
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly settings: {
      readonly customHeaderAndFooter?: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
      };
    } | null;
  } | null;
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type preloadLivePageDataQuery = {
  response: preloadLivePageDataQuery$data;
  variables: preloadLivePageDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "includeContentState"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCustomHeaderAndFooter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUsdSsr"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "status"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "value"
},
v12 = {
  "kind": "ScalarField",
  "name": "number"
},
v13 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v8/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      (v11/*: any*/),
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          (v12/*: any*/)
        ]
      }
    ]
  }
],
v14 = {
  "alias": "emojiTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v15 = {
  "alias": "emojiTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": "properties(key:\"emoji-title-draft\")"
},
v16 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "defaultTitleEmoji"
        }
      ]
    }
  ]
},
v17 = {
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": "properties(key:\"content-appearance-draft\")"
},
v18 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "coverPictureWidth"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "name"
},
v20 = {
  "kind": "ScalarField",
  "name": "color"
},
v21 = {
  "kind": "ScalarField",
  "name": "restrictionLevel"
},
v22 = {
  "condition": "includeContentState",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "isDraft",
          "value": false
        }
      ],
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "contentState",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isCallerPermitted"
        }
      ],
      "storageKey": "contentState(isDraft:false)"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "USER_FRIENDLY"
        }
      ],
      "concreteType": "ConfluenceDate",
      "kind": "LinkedField",
      "name": "contentStateLastUpdated",
      "plural": false,
      "selections": [
        (v11/*: any*/)
      ],
      "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }
  ]
},
v23 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "subType"
},
v25 = {
  "kind": "ScalarField",
  "name": "ncsStepVersion"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v27 = {
  "concreteType": "PaginatedLabelList",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v19/*: any*/)
      ]
    }
  ]
},
v28 = [
  {
    "kind": "ScalarField",
    "name": "html"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  },
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "concreteType": "SpaUnfriendlyMacro",
    "kind": "LinkedField",
    "name": "spaUnfriendlyMacros",
    "plural": true,
    "selections": [
      (v19/*: any*/)
    ]
  }
],
v29 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "concreteType": "SpaceSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "condition": "includeCustomHeaderAndFooter",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "SpaceSettingsMetadata",
              "kind": "LinkedField",
              "name": "customHeaderAndFooter",
              "plural": false,
              "selections": [
                {
                  "concreteType": "HtmlMeta",
                  "kind": "LinkedField",
                  "name": "header",
                  "plural": false,
                  "selections": (v28/*: any*/)
                },
                {
                  "concreteType": "HtmlMeta",
                  "kind": "LinkedField",
                  "name": "footer",
                  "plural": false,
                  "selections": (v28/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v30 = {
  "condition": "includeContentState",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "contentId",
          "variableName": "contentId"
        }
      ],
      "concreteType": "AvailableContentStates",
      "kind": "LinkedField",
      "name": "availableContentStates",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentState",
          "kind": "LinkedField",
          "name": "customContentStates",
          "plural": true,
          "selections": [
            (v19/*: any*/),
            (v20/*: any*/),
            (v8/*: any*/)
          ]
        },
        {
          "concreteType": "ContentState",
          "kind": "LinkedField",
          "name": "spaceContentStates",
          "plural": true,
          "selections": [
            (v19/*: any*/),
            (v20/*: any*/),
            (v8/*: any*/),
            (v21/*: any*/)
          ]
        }
      ]
    }
  ]
},
v31 = {
  "condition": "isUsdSsr",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "contentId"
        }
      ],
      "concreteType": "PublicLinkPage",
      "kind": "LinkedField",
      "name": "publicLinkPage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "pageId"
        },
        {
          "kind": "ScalarField",
          "name": "pageStatus"
        }
      ]
    }
  ]
},
v32 = {
  "alias": "user",
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "userId"
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "AtlassianUserPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "preloadLivePageDataQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v26/*: any*/)
                    ]
                  }
                ]
              },
              (v27/*: any*/)
            ]
          }
        ]
      },
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "preloadLivePageDataQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v10/*: any*/),
                      (v26/*: any*/)
                    ]
                  }
                ]
              },
              (v27/*: any*/)
            ]
          }
        ]
      },
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/)
    ]
  },
  "params": {
    "cacheID": "5c9cf02614830a7e386c9b23c475de1c",
    "id": "20c390566178c3ea43db41cfc15658fc912f9ab857f8252b9bfa2284af77da35",
    "metadata": {},
    "name": "preloadLivePageDataQuery",
    "operationKind": "query",
    "text": "query preloadLivePageDataQuery($userId:ID,$contentId:ID!,$spaceKey:String!,$isUsdSsr:Boolean!,$includeCustomHeaderAndFooter:Boolean!,$status:[String],$includeContentState:Boolean=true){content(id:$contentId,status:$status){nodes{id,status,type,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}},properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth},currentuser{favourited{isFavourite}}},contentState(isDraft:false)@include(if:$includeContentState){id,name,color,restrictionLevel,isCallerPermitted}\n      contentStateLastUpdated(format:USER_FRIENDLY)@include(if:$includeContentState){value},operations{operation,targetType},subType,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},labels{nodes{id,name}}}},space(key:$spaceKey){id,settings{customHeaderAndFooter@include(if:$includeCustomHeaderAndFooter){header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}},availableContentStates(contentId:$contentId)@include(if:$includeContentState){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}},publicLinkPage(pageId:$contentId)@include(if:$isUsdSsr){pageId,pageStatus},user:confluence_atlassianUser(id:$userId){id,displayName,photos{value,isPrimary}}}"
  }
};
})();

(node as any).hash = "f1408d473b3ac00c2b64d0db96032880";

export default node;
